import * as React from "react";
import { cn } from "../lib";

const Table = ({
  className,
  containerClassName,
  children,
  ...props
}: React.TableHTMLAttributes<HTMLTableElement> & {
  containerClassName?: string;
}) => (
  <div className={cn("relative w-full overflow-x-auto", containerClassName)}>
    <table
      className={cn("w-full border-collapse text-left text-[13px]", className)}
      {...props}
    >
      {children}
    </table>
  </div>
);

const TableHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) => (
  <thead
    className={cn(
      "border-b border-[#F2F4F7] text-[12px] font-medium text-[#475467]",
      className,
    )}
    {...props}
  />
);

const TableHead = ({
  className,
  ...props
}: React.ThHTMLAttributes<HTMLTableCellElement>) => (
  <th
    className={cn(
      "table-cell px-3 py-2.5 text-left align-middle text-[12px] font-medium text-[#475467]",
      className,
    )}
    {...props}
  />
);

const TableHeaderCell = TableHead;

const TableBody = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) => (
  <tbody
    className={cn("divide-y divide-[#F2F4F7] text-[13px] text-[#344054]", className)}
    {...props}
  />
);

const TableRow = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement>) => (
  <tr
    className={cn(
      "table-row border-b border-[#F2F4F7] transition-colors hover:bg-[#F9FAFB]/70",
      className,
    )}
    {...props}
  />
);

const TableCell = ({
  className,
  ...props
}: React.TdHTMLAttributes<HTMLTableCellElement>) => (
  <td
    className={cn(
      "table-cell whitespace-nowrap px-3 py-2.5 align-middle text-[13px] text-[#344054]",
      className,
    )}
    {...props}
  />
);

export {
  Table,
  TableHeader,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
};
